export const set_alert = (json_data) => ({
  type: 'set_alert',
  payload: json_data,
});
export const reset_alert = () => ({
  type: 'reset_alert'
});